import { useRequestClient } from '../lib/hooks/useRequestClient';
import { useLPMutation } from '../lib/hooks/useLPMutation';
import { apiEndpoints } from '../lib/apiEndpoints/apiEndpoints';

type StartVoluntaryTrainingMutationParams = {
  campaignId: string;
};

export const useStartVoluntaryTrainingMutation = () => {
  const kyInstance = useRequestClient();

  return useLPMutation<unknown, StartVoluntaryTrainingMutationParams>(async ({ campaignId }) => {
    const baseUrl = apiEndpoints.getAPIEndpoint('root');

    if (!baseUrl) {
      throw new Error('endpoint "root" is not defined');
    }

    const url = `${baseUrl}/voluntary-campaign/${campaignId}`;
    if (!kyInstance) {
      throw new Error('Missing RequestClientProvider');
    }

    return await kyInstance.get(url).json();
  });
};
